export const mapCartItemsToWagers = (items) =>
  items.map((item) => ({
    balls: item.balls ?? [],
    stake: item.stake,
    to_pay: item.to_pay,
    change_odds_agreement: item.change_odds_agreement ?? true,
    draw_id: item.draw_id,
    draw_number: item.draw_number ?? '',
    market_category: item.market_category,
    market_type: item.market_type,
    outcome: {
      id: item.outcome.id,
      odds: parseFloat(item.outcome.odds),
      outcome_type: item.outcome.outcome_type,
    },
    repeat_for_draws: item.repeat_for_draws,
    secondary_unique: item.secondary_unique,
  }));

const formatDeclineReason = (reason) => {
  const formatted = reason.replace(/_/g, ' ');
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

const arraysEqual = (a, b) => {
  if (a.length !== b.length) return false;
  return a.every((item, i) => item.type === b[i].type && item.value === b[i].value);
};

export const buildRegisteredBetsPayload = (addedBets, cartItems, totals) => ({
  bets_count: addedBets.length,
  bet_slip_id: addedBets[0]?.bet_slip_id ?? null,
  total_stake: totals.totalStake,
  total_potential_payout: totals.totalPotentialPayout,
  bets: addedBets.map((bet) => {
    const match = cartItems.find(
      (item) =>
        item.market_type === bet.market_type
        && arraysEqual(item.balls ?? [], bet.balls)
    );
    return {
      ticket_id: match?.ticket_id ?? null,
      bet_slip_id: bet.bet_slip_id,
      wager_set_ref: bet.wager_set_ref,
      draw_id: bet.draw_id,
      draw_number: bet.draw_number,
      draw_date: bet.draw_date,
      lottery_name: bet.lottery_name,
      market_category: bet.market_category,
      market_title: bet.market_title,
      market_type: bet.market_type,
      outcome: bet.outcome,
      balls: bet.balls,
      stake: bet.stake,
      repeat_for_draws: match?.repeat_for_draws ?? 1,
      status: bet.status,
    };
  }),
});

export const correlateBedsWithCartItems = (addedBets, cartItems) => {
  const acceptedIds = new Set();
  const declineErrors = {};

  for (const bet of addedBets) {
    const match = cartItems.find(
      (item) =>
        item.market_type === bet.market_type
        && arraysEqual(item.balls ?? [], bet.balls)
    );
    if (!match) continue;
    if (bet.status === 'accepted') {
      acceptedIds.add(match.id);
    } else {
      declineErrors[match.id] = formatDeclineReason(bet.decline_reason ?? 'Bet was declined');
    }
  }

  return { acceptedIds, declineErrors };
};

const extractErrorWagerMessages = (errorWagers, defaultMessage) => {
  const messages = errorWagers
    .flatMap((ew) => Object.values(ew.errors))
    .filter(Boolean)
    .join('; ');
  return messages || defaultMessage;
};

export const extractBetErrors = (response) => {
  if (response?.error) return response.error.msg;
  if (response?.error_wagers?.length > 0) {
    return extractErrorWagerMessages(response.error_wagers, 'Some bets failed to place');
  }
  return null;
};
